import { ADVISOR_CALL_OUTCOME_LABELS, type AdvisorCallOutcome } from '@lia/contracts';
import { CallIncoming01Icon, CallOutgoing01Icon } from '@hugeicons/core-free-icons';
import { cn } from '../../lib/cn.js';
import { StatusBadge, type StatusTone } from '../primitives/badge.js';
import { Icon } from '../primitives/icon.js';

// Advisor call history pieces (plan B7): the advisor-facing outcome of a call and its direction. Presentational only.

export const ADVISOR_CALL_OUTCOME_TONE: Record<AdvisorCallOutcome, StatusTone> = {
  answered: 'success',
  missed: 'warning',
  voicemail: 'accent',
  no_answer: 'neutral',
  busy: 'neutral',
  failed: 'danger',
  in_progress: 'info',
};

export function AdvisorCallOutcomeBadge({ outcome, className }: { outcome: AdvisorCallOutcome; className?: string }) {
  return (
    <StatusBadge tone={ADVISOR_CALL_OUTCOME_TONE[outcome]} className={className}>
      {ADVISOR_CALL_OUTCOME_LABELS[outcome]}
    </StatusBadge>
  );
}

export function CallDirectionLabel({ direction, className }: { direction: 'inbound' | 'outbound'; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-1 text-meta text-text-secondary', className)}>
      <Icon icon={direction === 'inbound' ? CallIncoming01Icon : CallOutgoing01Icon} className="size-3.5" aria-hidden />
      {direction === 'inbound' ? 'Entrante' : 'Saliente'}
    </span>
  );
}
